import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class ZuordnungTechnologieStromerzeugung extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    technologie_pronovo: string | null = null;
    technologie_stromerzeugung_id: number | null = null;

    // view fields:
    technologie_stromerzeugung: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'ZuordnungTechnologieStromerzeugung';
    }
}

export async function createNewZuordnungTechnologieStromerzeugung(): Promise<ZuordnungTechnologieStromerzeugung> {
    const model = createModel(ZuordnungTechnologieStromerzeugung, {});

    await model.save();
    return model;
}

export class ZuordnungTechnologieStromerzeugungCollection extends BaseCollection<ZuordnungTechnologieStromerzeugung> {
    protected modelCls = ZuordnungTechnologieStromerzeugung;

    public getModelClassName(): string {
        return 'ZuordnungTechnologieStromerzeugung';
    }
}
